export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: 'Tongits Land',

    /** 公司名称 */
    name: 'Mobile KIK Limited',
    /** 公司微信 */
    wechat: 'Tongits Land',
    /** 公司微信 */
    facebook: '@TongitsLandGlobal',
    /** 公司邮箱 */
    email: 'Tongits Land@Tongits Land.com',
    /** 公司手机 */
    phone: 'Tongits Land',
    /** 公司电话 */
    tel: 'Tongits Land',
    /** 公司地址 */
    address: 'Tongits Land',
    /** 备案号 */
    keepOnRecordIcp: 'Tongits Land',
    /** 备案号 */
    cookiePolicyPath: '/Legal/cookiePolicy',

    appDownLoadUrl: {
      ios:"https://apps.apple.com/us/app/id1507313633",
      android:"https://play.google.com/store/apps/details?id=com.mrpoker.homegame.texasholdem",
      pc:"https://cdn.tongitsLand.com/TongitsLand.apk",
      local:"/static/TongitsLand.apk"
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js